import { styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import type { UsageProductVariantTableRow } from './usage-product-variant-table-edit-types/usage-product-variant-table-row';

export const StyledUsageProductVariantTableEdit = styled(DataGrid<UsageProductVariantTableRow>)({
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    fontSize: '1rem',
  },
  // MUI X v9 cells default to display:block with line-height:<rowHeight> for
  // centering inline content. renderCell wrappers that are block elements (e.g.
  // the "Up to and including" column's Stack) ignore that and sit at the top, so
  // flex-center the cells and reset the inherited line-height.
  '& .MuiDataGrid-cell': {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 'normal',
  },
  '& .MuiDataGrid-cell--editing:focus-within': {
    display: 'flex',
    outline: 'none !important',
    border: 'solid #8FFF00 2px !important',
    boxShadow: 'none',
  },
  '& .MuiInputBase-input': {
    textAlign: 'center',
    fontSize: '1rem',
  },
});
